import React, { Component } from "react";
import SelectRider from "./SelectRider";
import RiderHeader from "./RiderHeader";
import RiderSection from "./RiderSection";
import { inject, observer } from "mobx-react";
import Cookies from "js-cookie";
import Loading from '../Loading'

const base = "check-in";

@inject("CheckInStore", "RiderStore", "HeaderStore")
@observer
class CheckIn extends Component {  
  handleSubmit = e => {
    const { CheckInStore } = this.props;
    e.preventDefault();
    CheckInStore.riderCheckIn();
  };
  
  handleReturns = e => {
    const { CheckInStore } = this.props;
    e.preventDefault();
    CheckInStore.riderReturns();
  }

  handleNext = e => {
    const { CheckInStore } = this.props;
    e.preventDefault();
    CheckInStore.next();
  };

  componentDidMount() {
    const { CheckInStore, HeaderStore, RiderStore } = this.props;
    
    HeaderStore.header = base;    
    CheckInStore.isSubmitted = false;
    CheckInStore.currentPage = 1;
    RiderStore.getRidersAll(Cookies.get('token'))
    CheckInStore.getDispatches()

    if (this.props.match.params.id) {
      HeaderStore.header = 'update'
      CheckInStore.getRiderAttendance(this.props.match.params.id)
    }
    
    window.addEventListener('keydown', (e) => {
        if (e.keyCode === 13) {
          if (!CheckInStore.isDisabled()) {
            if (CheckInStore.currentPage !== 3 && !CheckInStore.isReturn) {
              CheckInStore.next()
            }
            else if (CheckInStore.isReturn) {
              this.handleReturns(e)
            }
          }
        }
    })
  }

  render() {
    const { CheckInStore, RiderStore } = this.props;

    return (
      <div className={`${base}`}>
        {CheckInStore.isSubmitting && 
        <Loading />
        }
        <div className="container display--flex flex-column justify--center">
          {RiderStore.allRiders && RiderStore.allRiders.length > 0 ? (
            <form>
              {/* Section 1 */}
              {CheckInStore.currentPage === 1 && (
                <SelectRider
                  handleNext={this.handleNext}
                  base={base}
                  {...this.state}
                />
              )}
              {/* Section 2 */}
              {CheckInStore.currentPage > 1 && (
                <div className="section text--left">
                  <RiderHeader base={base} />
                  <RiderSection
                    base={base}
                    handleNext={this.handleNext}
                    {...this.state}
                    handleSubmit={this.handleSubmit}
                    handleReturns={this.handleReturns}
                  />
                </div>
              )}
            </form>
          ) : <div className="text--center">Loading...</div>}
        </div>
      </div>
    );
  }
}

export default CheckIn;



// WEBPACK FOOTER //
// ./src/components/checkIn/CheckIn.js